// constants.js or within your component file
export const features = [
    {
        title: 'Member Management',
        description: [
            "Optimize every member interaction from registration to renewal.",
            "Automate sign-ups, plan tracking, and renewal reminders",
            "Track workouts, attendance, and billing from a central hub",
            "Send real-time alerts and milestone updates",
            "Drive member loyalty with personalized communication",
        ],
        icon: 'fas fa-users-cog',
    },
    {
        title: 'Class Management',
        description: [
            "Take full control of your class operations.",
            "Set up and manage recurring sessions effortlessly",
            "Assign trainers and track real-time attendance",
            "Enable easy online bookings with reminders",
            "Improve attendance rates and resource utilization",
        ],

        icon: 'fas fa-calendar-alt',
    },
    // {
    //     title: 'Lead Management',
    //     description: [
    //         "Never miss a potential member.",
    //         "Automate follow-ups via email, SMS, and WhatsApp",
    //         "Monitor conversions with actionable insights",
    //         "Prioritize leads using smart engagement tracking",
    //         "Capture leads from web, WhatsApp, social media & offline sources",

    //     ],
    //     icon: 'fas fa-user-plus',
    // },
];


// constants.js or inline
export const faqs = [
    {
        id: 1,
        title: 'How does the WhatsApp Integration feature function?',
        content:
            'The WhatsApp Integration feature in EasyMembr software allows you to communicate with members directly through WhatsApp. You can send notifications, and updates about classes or promotions, and engage with members in real time, enhancing communication and member engagement.',
    },
    {
        id: 2,
        title: "What's the Pricing of Easymembr?",
        content:
            `Half-yearly - ₹6,999/- + taxes\nAnnual plan - ₹11,999/- + taxes\n2 Year - ₹19,999/- + taxes\n\nNote: The exciting part about choosing Easymembr is that you can use all the features in all three plans. Get a demo of the software with the help of our support team. Learn how the features work and then opt for the subscription that best suits your needs.`,
    },
    {
        id: 3,
        title: 'How does  check-in/check-out benefit your gym?',
        content:
            'The check-in/check-out benefits your gym by providing secure access control. It ensures that only registered members can enter your facility, preventing unauthorized access and enhancing overall security.',
    },
    {
        id: 4,
        title: 'What are the exciting features of Gym Management Software?',
        content:
            `Membership Management: Sign-ups, billing, renewals, and access control.\nScheduling & Booking: Manage classes and appointments.\nAttendance Tracking: Monitor client/staff activity and class participation.\nReporting & Analytics: Gain insights into revenue, member trends, and marketing effectiveness.`,
    },
    {
        id: 5,
        title: 'Can I send customized messages to my clients on their birthdays?',
        content:
            'Yes, you can send customized messages to your clients on their birthdays using our software. This personalized touch helps strengthen your relationship with members and adds value to their experience with your gym.',
    },
    {
        id: 6,
        title: 'How does the staff access/payroll feature work?',
        content:
            'The staff access/payroll feature in our gym management software works by allowing you to manage staff schedules, track attendance, and process payroll efficiently. You can set access levels for different staff roles and streamline administrative tasks, saving time and improving staff management.',
    },
];



export const mmfaqs = [
    {
        id: 1,
        title: "What happens when a member's plan expires?",
        content:
            'Automatically blocks check-ins when a member\'s plan expires. This ensures that only active members can use the gym facilities.',
    },
    {
        id: 2,
        title: 'How are members notified about their membership expiration?',
        content:
            'Members will receive notifications about their membership expiration through WhatsApp and text messages. This ensures that members are well-informed and can renew their membership promptly to avoid disruptions in their access.',
    },
    {
        id: 3,
        title: 'How can I track my membership usage and attendance?',
        content:
            'You can track your client\'s membership usage and attendance through the personal dashboard on the website or mobile app. It provides detailed reports on the visits and activities.',
    },
    {
        id: 4,
        title: 'Can I customize membership plans for different durations and sessions?',
        content:
            'Absolutely. The membership management feature allows you to create and customize various membership plans based on duration (e.g., monthly, quarterly) and session counts (e.g., 5 or 10 sessions). This flexibility helps meet diverse member needs.',
    },
    {
        id: 5,
        title: 'What features are available for managing special membership situations like freezes or holds?',
        content:
            'The software provides options to freeze memberships for a specified period (e.g., 15 days for vacations) or put memberships on hold for unpredictable situations. This ensures that members can manage their memberships according to their circumstances without losing their benefits.',
    },
];


export const leadFaqs = [
    {
        id: 1,
        title: 'How does Easymembr notify staff about new leads?',
        content:
            'Easymembr provides real-time notifications to staff members via the mobile app whenever a new lead is generated. This ensures your team can respond promptly to potential clients and efficiently manage inquiries.',
    },
    {
        id: 2,
        title: 'Can I generate leads directly from social media using Easymembr?',
        content:
            'Yes, with Easymembr, you can generate a QR code that can be posted on social media. When potential clients scan the QR code, they are directly added as leads in your system, enabling you to capture leads effortlessly from your social media outreach.',
    },
    {
        id: 3,
        title: 'How does Easymembr help manage and categorize leads?',
        content:
            'The software allows you to customize each lead\'s categories, follow-up types, sources, and statuses (like hot and cold). You can also add custom fields if needed, providing a tailored approach to managing and tracking all inquiries effectively.',
    },
    {
        id: 4,
        title: 'What tools does Easymembr offer for following up with leads?',
        content:
            'Easymembr automates the follow-up process by sending alerts for scheduled follow-ups through the mobile app. Additionally, it supports bulk SMS and WhatsApp messaging, even on festive days, to keep potential clients engaged.',
    },
    {
        id: 5,
        title: 'Can the performance of staff in handling leads be tracked?',
        content:
            'Yes, Easymembr includes features that allow you to track how many leads each staff member generates. This data helps evaluate staff performance and can be crucial for identifying high performers and areas needing improvement within your team.',
    },
];



export const classFaqs = [
    {
        id: 1,
        title: 'How does Easymembr notify members and instructors about class schedules?',
        content:
            'Easymembr sends automated notifications through the whatsApp and SMS to both members and instructors. This helps ensure all parties are informed about upcoming classes, cancellations, or changes in real time.',
    },
    {
        id: 2,
        title: 'Can members book classes directly through Easymembr?',
        content:
            'Yes, members can view and book available classes through the Easymembr platform. You can also share booking links or QR codes via social media or email to streamline the registration process.',
    },
    {
        id: 3,
        title: 'Can class categories and schedules be customized?',
        content:
            'Easymembr allows full customization of class types, time slots, durations, instructor assignments, and participant limits. You can also define your own categories and recurring class patterns to suit your studio’s operations.',
    },
    {
        id: 4,
        title: 'What tools are available for communicating class updates in bulk?',
        content:
            'You can use Easymembr to send bulk SMS or WhatsApp messages to notify participants about class reminders, changes, or announcements. These tools help maintain engagement and reduce absenteeism.',
    },
    {
        id: 5,
        title: 'Can instructor performance be tracked through the platform?',
        content:
            'Yes, Easymembr provides data on instructor performance, including attendance records, class feedback, and scheduling adherence. This helps in performance evaluations and operational planning.',
    },
];
